module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/celsius-bid-day-web-banner-d5d0c506c77c171d83aab2c809dc150e.jpg";